<template>
    <div>
       <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="众筹名称">
               <el-input v-model="formInline.activeName" placeholder="众筹名称" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item label="众筹编号">
               <el-input v-model="formInline.activeNo" placeholder="众筹编号" style="width:220px"></el-input>
            </el-form-item>
           <el-form-item>
               <el-button type="success" @click="handleCrowActiveConfigList">查询</el-button>
               <el-button type="success" @click="handleAddCrowInfo">新增</el-button>
           </el-form-item>
       </el-form>
       <el-table :data="crowActiveConfigList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                 v-show="!showDialog">
           <el-table-column type="index" label="序号" width="50"></el-table-column>
           <el-table-column prop="id" label="众筹主键" v-if='show' width="220"></el-table-column>
           <el-table-column prop="activeNo" label="众筹编号" width="220"></el-table-column>
           <el-table-column prop="activeName" label="众筹名称" width="220"></el-table-column>
           <el-table-column prop="issue" label="众筹期数" width="410"></el-table-column>
           <el-table-column prop="notice" label="投票提示" width="230"></el-table-column>
           <el-table-column prop="title" label="众筹主题"  width="220"></el-table-column>
           <el-table-column prop="createTime" label="创建时间" width="520"></el-table-column>
           <el-table-column label="操作" fixed="right" width="290">
               <template slot-scope="scope">
                <el-button type="success" size="mini" @click="handlePic(scope.row)">上传图片</el-button>
                <el-button type="success" size="mini" @click="handleCrowdProduct(scope.row)">众筹产品</el-button>
               </template>
           </el-table-column>
       </el-table>
       <div class="pagination-wrap" v-show="!showDialog">
           <el-pagination
                   background
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="formInline.currentPage"
                   :page-sizes="GCONFIG.pageSizes"
                   :page-size="formInline.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="formInline.recordsTotal">
           </el-pagination>
       </div>

        <!-- 众筹配置 -->
        <el-dialog title="众筹配置" :visible.sync="showDialog" center>
            <el-form :model="crowdActiveInfoFrom" :rules="rules" label-width="120px">
                <el-form-item label="众筹名称" prop="activeNo">
                    <el-select v-model="crowdActiveInfoFrom.activeNo" clearable placeholder="众筹活动">
                        <el-option v-for="item in activeList"
                                   :key="item.activeNo"
                                   :label="item.activeName"
                                   :value="item.activeNo">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="众筹期数" prop="issue">
                    <el-input v-model="crowdActiveInfoFrom.issue" placeholder="众筹期数"></el-input>
                </el-form-item>
                <el-form-item label="投票提示" prop="notice">
                    <el-input v-model="crowdActiveInfoFrom.notice" placeholder="投票提示"></el-input>
                </el-form-item>
                <el-form-item label="众筹主题" prop="title">
                    <el-input v-model="crowdActiveInfoFrom.title" placeholder="众筹主题"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="handleSaveCrowdActiveInfo(crowdActiveInfoFrom)" class="header-btn">
                    保 存
                </el-button>
            </div>
        </el-dialog>

       <el-dialog title="图片管理" :visible.sync="dialogFormVisibleUpload" center append-to-body>
           <el-form :model="openUploadForm" label-width="120px">
               <el-form-item label="众筹主键">
                  <el-input v-model="openUploadForm.proId" placeholder="众筹主键" :disabled="true"></el-input>
               </el-form-item>
               <el-form-item label="众筹名称">
                  <el-input v-model="openUploadForm.activeName" placeholder="众筹名称" :disabled="true"></el-input>
               </el-form-item>
               <el-form-item label="众筹编号">
                   <el-input v-model="openUploadForm.activeNo" placeholder="众筹编号" :disabled="true"></el-input>
               </el-form-item>
               <el-form-item label="图片类型" >
                   <el-select v-model="openUploadForm.typeId" clearable  placeholder="图片类型">
                       <el-option label="banner图" value="1"></el-option>
                       <el-option label="列表图" value="2"></el-option>
                       <el-option label="介绍图" value="3"></el-option>
                       <el-option label="介绍长图" value="4"></el-option>
                   </el-select>
               </el-form-item>
               <el-form-item label="图片众筹分类" >
                   <el-select v-model="openUploadForm.classId" clearable  placeholder="图片众筹分类">
                       <el-option label="众筹通用配置" value="1"></el-option>
                       <el-option label="众筹活动配置" value="2"></el-option>
                   </el-select>
               </el-form-item>

               <el-form-item label="上传图片">
                   <el-upload
                           multiple
                           :data="openUploadForm"
                           :with-credentials="true"
                           :show-file-list="false"
                           class="upload-demo"
                           :action="saveCrowdImagePath"
                           :on-success="uploadSuccess"
                           :before-upload="uploadBefore">
                       <el-button size="small" type="primary">点击上传</el-button>图片大小尽量不超过500k
                   </el-upload>
               </el-form-item>
           </el-form>

           <el-table :data="crowdPicList" stripe border center height="460">
               <el-table-column label="序号" type="index" width="60"></el-table-column>
               <el-table-column prop="id" label="图片" v-if='show' width="220"></el-table-column>
               <el-table-column prop="proId" label="众筹主键" v-if='show' width="220"></el-table-column>
               <el-table-column label="图片类型" :formatter="typeName" prop="type"></el-table-column>
               <el-table-column label="图片众筹分类" :formatter="classIdName" prop="classId"></el-table-column>
               <el-table-column label="图片展示">
                   <template slot-scope="scope">
                       <img :src="scope.row.picUrl" width="60" height="60" class="head_pic">
                   </template>
               </el-table-column>
               <el-table-column label="操作">
                   <template slot-scope="scope">
                       <el-button-group>
                           <el-button type="danger" size="mini" @click="deleCrowdPic(scope.row)">删除</el-button>
                       </el-button-group>
                   </template>
               </el-table-column>
           </el-table>
       </el-dialog>
    </div>
</template>
<script>
    import {getCrowActiveConfigList,saveCrowdImage,getCrowdPicList,deleCrowdPicInfo,saveCrowdActiveInfo,getActiveForOption} from '../../api/api'
    export default {
        data() {
            return {
                formInline: {
                    "activeName":"",
                    "activeNo":"",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                showDialog: false,
                loading: true,
                dialogFormVisibleUpload: false,
                openUploadForm: {
                    proId:"",
                    "activeName":"",
                    activeNo:"",
                    classId:"",
                    typeId: "",
                    imageName: "",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                },
                crowdActiveInfoFrom:{
                    activeNo:"",
                    issue:"",
                    notice:"",
                    title:""
                },
                activeList: [],
                saveCrowdImagePath: saveCrowdImage,
                crowActiveConfigList:[],
                crowdPicList:[]
            }
        },

        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.handleCrowActiveConfigList();
            this.getActiveOptionList();
        },

        methods: {
            handleCrowActiveConfigList(){
                this.loading = true;
                getCrowActiveConfigList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.crowActiveConfigList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleAddCrowInfo(){
                this.crowdActiveInfoFrom={
                                activeNo:"",
                                issue:"",
                                notice:"",
                                title:""
                            }
                this.showDialog = true;
            },

            handleSaveCrowdActiveInfo(crowdActiveInfoFrom){
                if(crowdActiveInfoFrom.activeNo==""){
                    this.$message({
                        message:"请选择活动",
                        type:'error'
                    });
                    return;
                }
                saveCrowdActiveInfo(crowdActiveInfoFrom).then((res) =>{
                    if (res.data.status == 200) {
                        this.handleCrowActiveConfigList();
                        this.showDialog=false;
                    }else {
                         this.$message({
                             showClose: true,
                             message: res.data.message,
                             type: 'error'
                         });
                     }
                });
            },

            getActiveOptionList(){
                if(this.activeList==undefined||this.activeList.length==0){
                    //查询活动选项
                    getActiveForOption({}).then((res) => {
                        //console.log(res);
                        this.activeList = res.data.value;
                    })
                }
            },
            handleCrowdProduct(row){
                this.$router.push({name: 'crowdActiveProductList',params:{activeNo:row.activeNo}})
            },

            handlePic(row){
                this.openUploadForm.proId = row.id;
                this.openUploadForm.activeNo = row.activeNo;
                this.openUploadForm.activeName = row.activeName;
                this.dialogFormVisibleUpload = true;
                this.handleCrowdPicList(row.id);
            },
            handleCrowdPicList(id){
                getCrowdPicList({proId:id}).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.crowdPicList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            uploadBefore(){
                const loading = this.$loading(this.GCONFIG.loadingParam);
            },
            uploadSuccess(res) {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                loading.close();
                if (res.status == 200) {
                    this.$notify({
                        title: '成功',
                        message: '上传成功',
                        type: 'success'
                    });
                    this.dialogFormVisible = false;
                    this.handleCrowdPicList(this.openUploadForm.proId);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
            },
            deleCrowdPic(row){
                this.$confirm('删除此数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleCrowdPicInfo({id:row.id}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.handleCrowdPicList(row.proId);
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});

            },
            typeName(row, column, cellValue) {
                if (row.type == 1) {
                  return "banner图";
                } else if (row.type == 2) {
                  return "列表图";
                }else if (row.type == 3) {
                   return "介绍图";
                }else if (row.type == 4) {
                   return "介绍长图";
                }else {
                   return "未知";
                }
            },

            classIdName(row, column, cellValue) {
                if (row.classId == 1) {
                    return "众筹通用配置";
                } else if (row.classId == 2) {
                    return "众筹活动配置";
                }else {
                    return "未知";
                }
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.handleCrowActiveConfigList();
            },

            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.handleCrowActiveConfigList();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/crowd/crowdActiveList.vue